// extracted by mini-css-extract-plugin
module.exports = {"bannerWrap":"banner_bannerWrap__t6Llo","title":"banner_title__3MjMN","titleMain":"banner_titleMain__24LmC"};